import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { mobxInjectSelect } from '../../utils';
import BEM from '../../bem';

const classes = BEM.with('Admin');

class ReactAdmin extends Component {
  static propTypes = {
    currentOrganizationId: PropTypes.string.isRequired,
    destroyIframe: PropTypes.func.isRequired,
    getIframe: PropTypes.func.isRequired,
    logGainsightAnalytics: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this._getIframe();
    window.addEventListener('message', this._handleTrackerEvent);
  }

  componentDidUpdate(prevProps) {
    const { destroyIframe } = this.props;
    if (prevProps.view !== this.props.view) {
      destroyIframe();
      this._getIframe();
    }
  }

  _getIframe() {
    const { currentOrganizationId, getIframe, view } = this.props;
    getIframe(this.iframeParent, currentOrganizationId, view);
  }

  _handleTrackerEvent = (event) => {
    const { logGainsightAnalytics } = this.props;
    const { data } = event;
    if (Array.isArray(data.args) && data?.args[0] === 'logPendoAnalytics') {
      const [, trackerData] = data.args;
      if (trackerData.parentPathName && trackerData.pathName) {
        logGainsightAnalytics({
          parentPathName: trackerData.parentPathName,
          pathName: trackerData.pathName,
        });
      }
    }
  };

  componentWillUnmount() {
    const { destroyIframe } = this.props;
    window.removeEventListener('message', this._handleTrackerEvent);
    destroyIframe();
  }

  render() {
    return <div className={classes()} ref={this._setIframeParent} />;
  }

  _setIframeParent = (ref) => {
    this.iframeParent = ref;
  };
}

export default mobxInjectSelect({
  messengerStore: ['currentOrganizationId'],
  reactAdminStore: ['destroyIframe', 'getIframe'],
  trackerStore: ['logGainsightAnalytics'],
})(ReactAdmin);
